/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface SectionSummary
 */
export interface SectionSummary {
    /**
     * 
     * @type {number}
     * @memberof SectionSummary
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SectionSummary
     */
    scorecardTemplateId?: number;
    /**
     * 
     * @type {string}
     * @memberof SectionSummary
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof SectionSummary
     */
    order?: number;
    /**
     * 
     * @type {Date}
     * @memberof SectionSummary
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SectionSummary
     */
    dateUpdated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SectionSummary
     */
    isDraft?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SectionSummary
     */
    rulesCount?: number;
}

/**
 * Check if a given object implements the SectionSummary interface.
 */
export function instanceOfSectionSummary(value: object): boolean {
    return true;
}

export function SectionSummaryFromJSON(json: any): SectionSummary {
    return SectionSummaryFromJSONTyped(json, false);
}

export function SectionSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'scorecardTemplateId': json['scorecardTemplateId'] == null ? undefined : json['scorecardTemplateId'],
        'name': json['name'] == null ? undefined : json['name'],
        'order': json['order'] == null ? undefined : json['order'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
        'rulesCount': json['rulesCount'] == null ? undefined : json['rulesCount'],
    };
}

export function SectionSummaryToJSON(value?: SectionSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'scorecardTemplateId': value['scorecardTemplateId'],
        'name': value['name'],
        'order': value['order'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'isDraft': value['isDraft'],
        'rulesCount': value['rulesCount'],
    };
}

